import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';

import useInsuranceInfo from '../../../hooks/useInsuranceInfo';

import { StyledNavMenuMobileSubMenuCardContent } from './NavMenuMobile.styled';

export default function NavMenuMobileSubMenuItem(props) {
  const { menuItems, tabIndex, toggleNavMenu } = props;

  const history = useHistory();

  const { type: insuranceType } = useInsuranceInfo();

  return (
    Array.isArray(menuItems) &&
    menuItems.map((menuItem) => {
      const { link, text, icon, externalUrl, displayForInsuranceTypes } = menuItem;

      if (
        Array.isArray(displayForInsuranceTypes) &&
        !displayForInsuranceTypes.includes(insuranceType)
      )
        return null;

      return (
        <Card elevation={0} key={text}>
          <CardActionArea
            tabIndex={tabIndex}
            aria-label={text}
            onClick={() => {
              toggleNavMenu();

              if (externalUrl) {
                window.open(link, '_blank');
              } else {
                history.push(link);
              }
            }}
          >
            <CardContent>
              <StyledNavMenuMobileSubMenuCardContent>
                <img src={icon} alt={text} />
                <Typography variant="p">{text}</Typography>
              </StyledNavMenuMobileSubMenuCardContent>
            </CardContent>
          </CardActionArea>
        </Card>
      );
    })
  );
}
